import { UnknownAction } from 'redux'
import type { DesignPersonalizationContext } from '@vp/personalization-types'
import { DESIGN_PERSONALIZATION_CONTEXT_UPDATE, DESIGN_PERSONALIZATION_CONTEXT_ID_UPDATE, DPCS_LOADING_UPDATE } from './reducer'

export const designPersonalizationContextUpdate = (dpc?: DesignPersonalizationContext | undefined): UnknownAction => ({
  type: DESIGN_PERSONALIZATION_CONTEXT_UPDATE,
  payload: { dpc },
})

export const designPersonalizationContextIdUpdate = (id?: string | undefined): UnknownAction => ({
  type: DESIGN_PERSONALIZATION_CONTEXT_ID_UPDATE,
  payload: { id },
})

export const dpcsLoadingUpdate = (dpcsLoading: boolean): UnknownAction => ({
  type: DPCS_LOADING_UPDATE,
  payload: { dpcsLoading },
})
